import { render } from "./CustomerTransactions.vue?vue&type=template&id=4ba609fe&scoped=true"
import script from "./CustomerTransactions.vue?vue&type=script&lang=js"
export * from "./CustomerTransactions.vue?vue&type=script&lang=js"

import "./CustomerTransactions.vue?vue&type=style&index=0&id=4ba609fe&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba609fe"]])

export default __exports__